<template>
  <div>
    <v-chip-group
      column
      active-class="primary--text"
    >
      <v-chip
        v-for="domain in domains"
        :key="domain"
        style="margin-right: 2px; font-size: 16px"
        color="indigo"
        close
        small
        outlined
        label
        @click:close="removeDomain(domain)"
      >
        {{domain}}
      </v-chip>
    </v-chip-group>
    <div
      class="multiple-inputs-wrap"
      style="white-space: nowrap; padding-top: 5px"
    >
      <div class="form__input-box form__input-box--small">
          <label>
              <input
                type="text"
                class="form__input"
                placeholder="exclude domain"
                v-model="excludeDomain"
                v-input-trim
                :class="this.errorMsgs.length > 0 ? 'is-error' : ''"
              >
          </label>
      </div>
      <div class="global-redirects-page__right-btns" >
          <v-btn outlined color="indigo"
                  @click="addNewDomain()">
              <span>add</span>
          </v-btn >
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    name: 'ExcludeDomains',
    props: ['domains'],
    data () {
      return {
        excludeDomain: '',
        errorMsgs: []
      }
    },
    methods: {
      addNewDomain: function () {
        this.errorMsgs = []
        const domains = this.domains ? [...this.domains] : []

        if (this.excludeDomain === '') {
          this.errorMsgs.push('Excluded domain can not be empty')
        }
        if (this.excludeDomain.indexOf(' ') >= 0) {
          this.errorMsgs.push('Excluded domain can not contains white spaces')
        }
        if (this.excludeDomain.indexOf('/') >= 0 || this.excludeDomain.indexOf('http:') >= 0 || this.excludeDomain.indexOf('https:') >= 0) {
          this.errorMsgs.push('Excluded domain can not contains any symbols like / or protocols')
        }
        if (!/^[a-zA-Z0-9][a-zA-Z0-9-]{1,61}[a-zA-Z0-9](?:\.[a-zA-Z]{2,})+$/.test(this.excludeDomain)) {
          this.errorMsgs.push('Invalid domain name')
        }

        if (this.errorMsgs.length === 0) {
          domains.push(this.excludeDomain)
          this.excludeDomain = ''
        }

        this.$emit('update', { domains, errorMsgs: this.errorMsgs })
      },
      removeDomain: function (domain) {
        const domains = this.domains ? this.domains.filter(d => d !== domain) : []
        this.$emit('update', { domains, errorMsgs: this.errorMsgs })
      }
    }
  }
</script>
<style scoped lang="scss" src="./GlobalRedirectsPage.scss"></style>
